import { mkInput, mkType, type SchemaToType } from '@main/schema-utils';

import {
  DiscoClassScanStatus,
  DiscoClassScanType,
} from './enums/discoClassScan';

export const DiscoClassScanConfig = mkType({
  name: 'DiscoClassScanConfig',
  comment: 'A configuration for a disco class scan',
  fields: {
    id: {
      comment: 'The ID of the disco class scan config',
      type: 'id',
      modelName: 'discoClassScanConfig',
    },
    type: {
      comment: 'The scan type',
      type: { DiscoClassScanType },
    },
    enabled: {
      comment: 'If the scan is enabled',
      type: 'boolean',
    },
    scheduleFrequency: {
      comment: 'How frequently the scan should be run in milliseconds',
      type: 'int',
    },
    lastStatus: {
      comment: 'The status of the last scan',
      type: { DiscoClassScanStatus },
      optional: true,
    },
    lastStartAt: {
      comment: 'When the last scan started',
      type: 'Date',
      optional: true,
    },
    lastCompletedAt: {
      comment: 'When the last scan completed',
      type: 'Date',
      optional: true,
    },
    scheduleStartAt: {
      comment: 'When the next scan should start (null if disabled)',
      type: 'Date',
      optional: true,
    },
  },
});

/** Override type */
export type DiscoClassScanConfig = SchemaToType<typeof DiscoClassScanConfig>;

export const DiscoClassScanConfigQueryInput = mkInput({
  name: 'DiscoClassScanConfigQueryInput',
  comment: 'Input for a disco class scan config query',
  fields: {
    dataSiloId: {
      comment: 'The ID of the data silo to query',
      type: 'id',
      modelName: 'dataSilo',
    },
  },
});

/** Override type */
export type DiscoClassScanConfigQueryInput = SchemaToType<
  typeof DiscoClassScanConfigQueryInput
>;
